module.exports = __webpack_public_path__ + "img/w.161cf7bb.jpg";